import React from "react"
import ReactDOM from "react-dom/client"
import App from "./app"
import "bootstrap/dist/css/bootstrap.min.css"
import "./styles/index.css"
import "./styles/tags.css"
import "./styles/bootstrap.css"
import "./styles/buttons.css"


ReactDOM.createRoot(document.getElementById("root")).render(
    <React.StrictMode>
        <App/>
    </React.StrictMode>,
)
